<template>
  <meta-overlay v-model="isVisible" append-to-body close-by-mark transition="tra-scaleIn">
    <div class="download-bg" @click.stop>
      <div class="title">
        <p>打开233乐园，</p>
        <p>兑换好礼！</p>
      </div>
      <div class="desc">
        <p>你还未安装233乐园，快下载安装233乐园，进入商城兑换好礼！</p>
        <p class="desc-size">商城位置:【我的-右上角更多-物品商城】</p>
      </div>
      <img
        class="close-icon"
        src="@@/assets/imgs/close-mask.png"
        alt=""
        @click="isVisible = false"
      />
      <div class="download-btn" @click="downLoad">立即下载</div>
    </div>
  </meta-overlay>
</template>
<script lang="ts" setup>
import { pandora } from "~/utils";

const isVisible = ref(false);
const data = ref<any>({});

/**
 * @description 判断设备和版本
 * @return {void}
 */
const isAndroidVersionGreaterThan6 = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (userAgent.includes("android")) {
    const match = userAgent.match(/android\s([0-9.]*)/);
    if (match) {
      const androidVersion = parseFloat(match[1]);
      return androidVersion > 6.0;
    }
  }
  return false;
};
/**
 * @description 下载233乐园
 * @return {void}
 */
const downLoad = () => {
  if (isAndroidVersionGreaterThan6()) {
    window.location.href = "https://api.233lyly.com/apiserv/api/deliveryTest/ABTest?id=guanwang";
  } else {
    window.location.href =
      "https://api.233lyly.com/apiserv/api/deliveryTest/ABTest?id=guanwang_32";
  }

  pandora(
    "event_goods_share_detail_download_pop_download_click",
    "福利商城-商品分享落地页-下载引导弹窗的下载点击",
    data.value
  );
};

defineExpose({
  open: (_data: any) => {
    isVisible.value = true;
    data.value = _data;
  },
  close: () => {
    isVisible.value = false;
  }
});
</script>
<style scoped lang="scss">
.download-bg {
  background: url(~/business/assets/imgs/download-bg.png) no-repeat;
  background-size: 100% 100%;
  width: 12.45rem;
  height: 13.4rem;
  position: relative;

  .title {
    font-size: 0.89rem;
    font-weight: bold;
    color: #fff;
    position: absolute;
    top: 2.6rem;
    left: 0.8rem;
  }

  .desc {
    width: 12.45rem;
    font-size: 0.622rem;
    padding: 0 0.9rem;
    position: absolute;
    top: 6.6rem;
    color: rgba(160, 79, 0, 1);

    .desc-size {
      font-size: 0.535rem;
      margin-top: 0.3rem;
    }
  }

  .download-btn {
    background-color: rgba(255, 114, 16, 1);
    width: 10.3rem;
    height: 1.96rem;
    border-radius: 1rem;
    font-size: 0.66rem;
    display: flex;
    color: white;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: calc(50% - 5.15rem);
    bottom: 0.8rem;
  }

  .close-icon {
    width: 1.1rem;
    height: 1.1rem;
    position: absolute;
    bottom: -1.7rem;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
